import { useEffect, useState } from 'react';

export const useKonamiCode = () => {
  const [konamiSequence, setKonamiSequence] = useState([]);
  const [konamiMode, setKonamiMode] = useState(false);

  useEffect(() => {
    const handleKeyDown = (e) => {
      // Only track Konami code when not in input fields
      if (['INPUT', 'TEXTAREA'].includes(document.activeElement.tagName)) {
        return;
      }

      // Konami code: ↑ ↑ ↓ ↓ ← → ← → B A
      const konamiCode = ['ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight', 'b', 'a'];
      const newSequence = [...konamiSequence, e.key].slice(-10);
      setKonamiSequence(newSequence);
      
      const sequenceMatch = newSequence.every((key, i) => key === konamiCode[i]);
      
      if (sequenceMatch && newSequence.length === 10) {
        setKonamiMode(prev => !prev);
        setKonamiSequence([]);
        setTimeout(() => {
          alert(konamiMode ? '🎮 Konami mode deactivated!' : '🎮 KONAMI CODE ACTIVATED! Secret pattern unlocked!');
        }, 100);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [konamiSequence, konamiMode]);

  return konamiMode;
};